import React from 'react';
import { CalendarCheckIcon, PackageIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { equipment, facilities } from '../../data/loisirs';
export function BookingServices() {
  return <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:gap-10" data-id="element-1463" data-mp="1woe9ak2foqzi">
      <section aria-labelledby="espaces-titre" data-id="element-1464" data-mp="1wm1j5jmivabd">
        <h2 id="espaces-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1465" data-mp="21o0o2xxwufaf">
          Réserver un espace
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1466" data-mp="2pafhk0hiw8ng">Salles, gymnases, terrains et patinoires.</p>

        <p className="mt-4 flex items-start gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm text-ville-navy" data-id="element-1467" data-mp="2tc11g5sh5n75">
          <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1468" data-mp="2kdgntj1ru3ps" />
          « Je cherche une salle pour 20 personnes samedi après-midi. » — voici les espaces proposés par ATNA.
        </p>

        <ul className="mt-4 space-y-3" data-id="element-1469" data-mp="18ythdboayje3">
          {facilities.map(facility => <li key={facility.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1470" data-mp="3o4hm4jq8la3a">
              <div className="min-w-0 flex-1" data-id="element-1471" data-mp="3k5il3a7mlxh4">
                <p className="font-bold text-ville-navy" data-id="element-1472" data-mp="1ykpzwrj735r">{facility.name}</p>
                <p className="mt-0.5 text-sm text-slate-500" data-id="element-1473" data-mp="3t443n5d3lchw">
                  {facility.place} · {facility.availability}
                </p>
                <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1474" data-mp="awobit2inzxk">
                  <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-1475" data-mp="6vuoe1wwep5q" />
                  {facility.capacity}
                </p>
              </div>
              <div className="text-right" data-id="element-1476" data-mp="kpvi2h8ztlz8">
                <p className="font-extrabold text-ville-navy" data-id="element-1477" data-mp="fpz9s5t9j8dv">{facility.price}</p>
                <button type="button" className="mt-2 rounded-full bg-ville-navy px-4 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1478" data-mp="ulp18jh7wdpz">
                  Réserver
                </button>
              </div>
            </li>)}
        </ul>

        <p className="mt-3 flex items-center gap-2 text-xs text-slate-500" data-id="element-1479" data-mp="16mevk1hlqun4">
          <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1480" data-mp="1bgsw0ib4fryn" />
          Une fois confirmée, la réservation est ajoutée à votre carte numérique et la facture à Mon profil.
        </p>
      </section>

      <section aria-labelledby="equipement-titre" data-id="element-1481" data-mp="1keblbyvsssgc">
        <h2 id="equipement-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1482" data-mp="1pehh9r93p148">
          Louer de l’équipement
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1483" data-mp="1udkeipiua31n">Équipement sportif et matériel communautaire.</p>

        <ul className="mt-4 space-y-3" data-id="element-1484" data-mp="3r86yacu5ap5f">
          {equipment.map(item => <li key={item.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1485" data-mp="uj23ctols5">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy" aria-hidden="true" data-id="element-1486" data-mp="3juy0dvwudn85">
                <PackageIcon className="h-5 w-5" data-id="element-1487" data-mp="3ewmntdf5wym8" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-1488" data-mp="39xte7w2zxrrc">
                <p className="font-bold text-ville-navy" data-id="element-1489" data-mp="39uxga7r5f32w">{item.name}</p>
                <p className="text-sm text-slate-500" data-id="element-1490" data-mp="bew5fkqqoyds">
                  {item.detail} · {item.availability}
                </p>
              </div>
              <div className="text-right" data-id="element-1491" data-mp="1gyir1oj39na">
                <p className="font-extrabold text-ville-navy" data-id="element-1492" data-mp="1fx5qrnycd2x">{item.price}</p>
                <button type="button" className="mt-2 rounded-full border border-ville-navy px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1493" data-mp="3soazxgpevn37">
                  Réserver
                </button>
              </div>
            </li>)}
        </ul>

        <p className="mt-3 text-xs text-slate-500" data-id="element-1494" data-mp="3w4mcicb091lw">
          Présentez votre carte numérique au moment de la cueillette.
        </p>
      </section>
    </div>;
}